import { Component, Output, EventEmitter, Input } from "@angular/core";

@Component({
    selector: "attachment-handler",
    template: require('./attachment-handler.component.html'),
    styles: [require('./label-button.css')]
})
export class AttachmentHandler {

    private existingFileShouldBeRemoved: boolean = false;

    constructor() {
        this.maxNrMBytes = 20;
        this.isReadonly = false;
    }

    get hasExistingNonRemovedFile(): boolean {
        return this.hasExistingFile && !this.existingFileShouldBeRemoved;
    }

    newFile: File = null;

    @Input()
    hasExistingFile: boolean;

    @Input()
    maxNrMBytes: number;

    @Input()
    isReadonly: boolean;

    @Output()
    onDownloadExistingFile = new EventEmitter<void>();

    @Output()
    onExistingFileShouldBeRemoved = new EventEmitter<void>();

    @Output()
    onNewFileChanged = new EventEmitter<File>();

    downloadExistingFile(): void {
        this.onDownloadExistingFile.emit();
    }

    removeExistingFile(): void {
        this.existingFileShouldBeRemoved = true;
        this.onExistingFileShouldBeRemoved.emit();
    }

    handleNewFile(file: File): void {
        if (!file) {
            return;
        }

        if (file.size > this.maxNrMBytes * 1024 * 1024) { // 20 mb
            alert("Maximum allowed file size is " + this.maxNrMBytes + " MB.");
            return;
        };

        this.newFile = file;
        this.emitNewFileChange();
    }

    removeNewFile(): void {
        this.newFile = null;
        this.emitNewFileChange();
    }

    private emitNewFileChange(): void {
        this.onNewFileChanged.emit(this.newFile);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/attachment-handler.component.ts